module.exports = __webpack_public_path__ + "static/media/cpg_mobile_nbccom_video.d3ce814f.png";